import React, { useEffect, useState } from 'react';
import { MigrationDashboard } from '.';
import { getUserRole } from '../../lib/helpers';
import { useMigrationData } from './hooks/useMigrationData';
import { useBackupData } from './hooks/useBackupData';
import { useDisasterRecoveryData } from './hooks/useDisasterRecoveryData';
import { isDiscoveryEnabled, isMigrationEnabled } from '../../layout/sidebar/hooks/useNavigation';
import { DiscoveryDashboard } from '../Discovery/Dashboard';
import { NotificationsPanel } from '../../components/NotificationsPanel';
import './Home.scss';
import { useNotificationsPanel } from '../../providers/NotificationsPanelProvider';
import WOWO from '../../lib/wowo';
import { NewMigrationDashboard } from './NewMigrationDashboard';

export const HomePageWrapper = () => {
    const [userOrg, setUserOrg] = useState(() => sessionStorage.getItem('userOrg'));
    const [hideBackupBlock, setHideBackupBlock] = useState(false);
    const [hideDrBlock, setHideDrBlock] = useState(false);
    const [hideMigrationsBlock, setHideMigrationsBlock] = useState(false);

    // Hook for fetching and displaying Migration card data
    const { migrationData, newMigrationData } = useMigrationData({
        userOrg,
        hideMigrationsBlock,
        setHideMigrationsBlock,
        hideDrBlock,
        hideBackupBlock,
    });

    // Hook for fetching and displaying Backup card data
    const { backupData } = useBackupData({
        userOrg,
        hideMigrationsBlock,
        setHideMigrationsBlock,
        setHideDrBlock,
        hideBackupBlock,
        setHideBackupBlock,
    });

    // Hook for fetching and displaying Disaster Recovery card data
    const { disasterRecoveryData } = useDisasterRecoveryData({
        userOrg,
        hideDrBlock,
        setHideDrBlock,
        setHideBackupBlock,
        hideMigrationsBlock,
    });

    // Get the user org from session storage when the page initially loads
    useEffect(() => {
        let storedUserOrg = sessionStorage.getItem('userOrg');
        setUserOrg(storedUserOrg);
    }, []);

    const { notifications, isLoading: isNotificationsLoading } = useNotificationsPanel();

    // Render DiscoveryDashboard if discovery is enabled
    const showDiscovery = isDiscoveryEnabled();
    // Render MigrationDashboard if migration is enabled
    const showMigration = isMigrationEnabled();
    // Render NewMigrationDashboard if new_dashboard_cards flag is enabled
    const showNewDashboardCards = WOWO.isEnabled('new_dashboard_cards');

    return (
        <div className="home">
            <NotificationsPanel notifications={notifications} isLoading={isNotificationsLoading} />
            {showDiscovery && <DiscoveryDashboard />}
            {showMigration && showNewDashboardCards && (
                <NewMigrationDashboard newMigrationData={newMigrationData} getUserRole={getUserRole} />
            )}
            {showMigration && !showNewDashboardCards && (
                <MigrationDashboard
                    migrationData={migrationData}
                    backupData={backupData}
                    disasterRecoveryData={disasterRecoveryData}
                    getUserRole={getUserRole}
                />
            )}
        </div>
    );
};
